// Types
import type { ReactNode } from 'react';
import { useContext } from 'react';

import {
    DndContext,
    KeyboardSensor,
    PointerSensor,
    rectIntersection,
    useSensor,
    useSensors
} from '@dnd-kit/core';
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers';
import type { SortingStrategy } from '@dnd-kit/sortable';
import { arrayMove, SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';

// Components
import { CompoundTableContext } from '@/components/base/Table/CompoundTable';

function TableHeaderDragAndDropContext({ children }: { children: ReactNode }) {
    const { table } = useContext(CompoundTableContext);
    const { getState, setColumnOrder } = table;
    const { columnOrder } = getState();

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    function disableSortingStrategy(): ReturnType<SortingStrategy> {
        return null;
    }

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={rectIntersection}
            modifiers={[restrictToHorizontalAxis]}
            onDragOver={(event) => {
                const { active, over } = event;
                if (over?.id && active.id !== over.id) {
                    const oldIndex = columnOrder.findIndex((column) => column === active.id);
                    const newIndex = columnOrder.findIndex((column) => column === over.id);
                    const newColumnOrder = arrayMove(columnOrder, oldIndex, newIndex);
                    setColumnOrder(newColumnOrder);
                }
            }}>
            <SortableContext items={columnOrder} strategy={disableSortingStrategy}>
                {children}
            </SortableContext>
        </DndContext>
    );
}

export default TableHeaderDragAndDropContext;
